import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-product-unit-data',
  templateUrl: './product-unit-data.component.html',
  styleUrls: ['./product-unit-data.component.css']
})
export class ProductUnitDataComponent implements OnInit {
    productUnitDataKeyno;

    public edit?: Edit;

    public selectListFactorInputMethods: FactorInputMethodItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.productUnitDataKeyno = this.stateService.getStateParams()['productunitdata_keyno'];
    }

    private async loadEdit() {
        if (!!this.productUnitDataKeyno) {
            this.edit = (await this.datatask.Post(587, { productunitdata_keyno: this.productUnitDataKeyno }))[0];
        }
    }

    private async loadFactorInputMethods() {
        if (!this.edit) return;

        this.selectListFactorInputMethods = await this.datatask.Post(2946, { productunitdata_keyno: this.edit.productunitdata_keyno });
    }

    private async retrieveInputMethod() {
        if (!this.edit) return;

        const response = (await this.datatask.Post(2947, this.edit))[0];

        this.edit.qtyfactor = response.qtyfactor;
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(589, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    public onChanged(_: string, id: keyof Edit) {
        switch (id) {
            case 'productunitdata_factor_input_method_no':
                if (!this.edit) return;

                this.retrieveInputMethod();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadFactorInputMethods();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    productunitdata_keyno: string;
    prodsize_keyno: string;
    prod_id: string;
    prod_name: string;
    unit_shortname: string;
    qtyfactor: string;
    prodsize_name: string;
    isbaseunit: string;
    productunitdata_factor_input_method_no: string;
}

interface FactorInputMethodItem {
    method_no: string;
    method_name: string;
}
